// todo: AccountCard from swagger

import { AccountCard } from 'sites/happybet/lib/api/uniqueAccountCardsResponseApi';
import { SessionUser } from 'next-auth';
import { ApiStatus } from 'features/api/thunkUtils';

export type CacheToken = Record<number, string>;

export type AuthTokenType = {
  ts: number;
  clientIP?: string;
  expiresIn: number;
  expireDate: number;
  accessToken: string;
  refreshToken?: string;
};

export type AuthState = {
  user?: SessionUser;
  token?: AuthTokenType;
  signOut?: Date;
  isLogged: boolean;
  apiStatus: ApiStatus;
  selectedPaymentType?: string | null;
  // accessToken: string | null;
  cacheTokens: CacheToken;
  // masterToken?: string | null;
  selectedCard?: AccountCard;
  // expirationDate: number | null;
  // isSessionLoading?: boolean;
  refreshAssociatedToken?: string | null;
};

export const initialState: AuthState = {
  user: undefined,
  token: undefined,
  isLogged: false,
  cacheTokens: {},
  apiStatus: ApiStatus.uninitialized,
};
